export const SET_COMPANIES = 'companies/set';
export const SET_QUERY = 'companies/setQuery';
export const RESET_QUERY = 'companies/resetQuery';
export const SET_LOADING = 'companies/setLoading';
